// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/deployment_profiling_service.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { DeploymentComposition } from "./deployment_composition_pb.js";
import { KubernetesResourceSpec } from "./kubernetes_resource_spec_pb.js";

/**
 * The request message to list scoring compositions support for profiling.
 *
 * @generated from message ai.h2o.deploy.ListSuggestedScoringCompositionsRequest
 */
export const ListSuggestedScoringCompositionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.ListSuggestedScoringCompositionsRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * The response message to return list of deployment compositions.
 *
 * @generated from message ai.h2o.deploy.ListSuggestedScoringCompositionsResponse
 */
export const ListSuggestedScoringCompositionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.ListSuggestedScoringCompositionsResponse",
  () => [
    { no: 1, name: "deployment_compositions", kind: "message", T: DeploymentComposition, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * The request message to get suggested resource spec for given composition.
 *
 * @generated from message ai.h2o.deploy.GetSuggestedScoringResourceSpecRequest
 */
export const GetSuggestedScoringResourceSpecRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.GetSuggestedScoringResourceSpecRequest",
  () => [
    { no: 1, name: "deployment_composition", kind: "message", T: DeploymentComposition },
    { no: 2, name: "workers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * The response message to represent suggested resource spec.
 *
 * @generated from message ai.h2o.deploy.GetSuggestedScoringResourceSpecResponse
 */
export const GetSuggestedScoringResourceSpecResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.GetSuggestedScoringResourceSpecResponse",
  () => [
    { no: 1, name: "kubernetes_resource_spec", kind: "message", T: KubernetesResourceSpec },
  ],
);

